import { onMounted, onBeforeUnmount } from 'vue'

/**
 * Register key handlers.
 *
 * Unfortunately keydown / keyup handler cannot be separated...
 *  - keydown/keyup handler are NOT guaranteed to be paired 1-1.
 *
 * @param handlers: keyDown / keyUp Handler
 */
export function useKeyHandler (handlers: {
  keyDown?: (key: string, ev: KeyboardEvent) => boolean
  keyUp?: (key: string, ev: KeyboardEvent) => void
}): void {
  const { keyDown, keyUp } = handlers

  onMounted(() => {
    document.addEventListener('keydown', onKeyDown)
    document.addEventListener('keyup', onKeyUp, { capture: true })
  })

  onBeforeUnmount(() => {
    document.removeEventListener('keydown', onKeyDown)
    document.removeEventListener('keyup', onKeyUp, { capture: true })
  })

  const isKeydownProcessed: { [key: string]: boolean } = {}

  function onKeyDown (ev: KeyboardEvent): void {
    if (ev.repeat) return

    const keyString = ev.code
    // console.log('onKeyDown', ev, keyString, Date.now())

    if ((keyDown?.(keyString, ev)) ?? false) {
      isKeydownProcessed[keyString] = true
      ev.stopPropagation()
      ev.preventDefault()
    }
  }

  function onKeyUp (ev: KeyboardEvent): void {
    const keyString = ev.code
    // console.log('onKeyUp', ev, keyString, Date.now())

    if (isKeydownProcessed[keyString]) {
      if (keyUp != null) keyUp(keyString, ev)
      isKeydownProcessed[keyString] = false
    }
  }
}
